import { useQuery } from "@tanstack/react-query";
import { getSupabaseClient } from "../providers/supabase/supabase";
import { OwnerOnlyNotice } from "./OwnerOnly";
import { useDuenoStatus } from "./useIsDueno";
import { useOffers } from "./useOffers";

export const NO_OFFERS_MESSAGE =
  "Aún no tienes ofertas asignadas; pídelas al dueño.";
export const NO_ZONE_MESSAGE =
  "Aún no tienes zona asignada (estados o municipios); pídela al dueño. Mientras tanto no verás empresas en el directorio.";
export const DAILY_CAP_MESSAGE =
  "Llegaste a tu tope diario de promociones; se reinicia a medianoche (hora de México)";

/** E6.6 · Promociones de hoy y tope del usuario (tope null = sin tope, p. ej. el dueño). La base es quien limita. */
export const usePromotionsToday = () =>
  useQuery({
    queryKey: ["promotions_today"],
    queryFn: async () => {
      const { data, error } = await getSupabaseClient().rpc("promotions_today");
      if (error) throw error;
      return data as { usadas: number; tope: number | null } | null;
    },
  });

/** true solo para un freelancer cuya zona no tiene estados (zona vacía = sin acceso). */
export const useMyZoneEmpty = (): boolean => {
  const dueno = useDuenoStatus();
  const { data } = useQuery({
    queryKey: ["my_zone"],
    enabled: dueno === "no",
    queryFn: async () => {
      // RLS: un freelancer solo lee su propia fila
      const { data, error } = await getSupabaseClient()
        .from("member_entitlements")
        .select("tier, dir_estados")
        .maybeSingle();
      if (error) throw error;
      return data as { tier: string; dir_estados: string[] } | null;
    },
  });
  return data?.tier === "publico" && data.dir_estados.length === 0;
};

/** Aviso (no error) cuando quien no es el dueño no tiene ofertas asignadas. */
export const NoOffersNotice = () => {
  const dueno = useDuenoStatus();
  const { data: offers } = useOffers();
  if (dueno !== "no" || !offers || offers.length > 0) return null;
  return <OwnerOnlyNotice message={NO_OFFERS_MESSAGE} />;
};

/** Aviso (no error) cuando el freelancer no tiene zona asignada. */
export const NoZoneNotice = () =>
  useMyZoneEmpty() ? <OwnerOnlyNotice message={NO_ZONE_MESSAGE} /> : null;
